import React from 'react';

function Plus() {
    return (
        <path d="M23.5,11.5h-11v-11C12.5,0.2,12.3,0,12,0s-0.5,0.2-0.5,0.5v11h-11C0.2,11.5,0,11.7,0,12s0.2,0.5,0.5,0.5h11v11
            c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-11h11c0.3,0,0.5-0.2,0.5-0.5S23.8,11.5,23.5,11.5z"
        />
    );
}

export default Plus;
